export default "__VITE_ASSET__483cee42__"